$(document).ready(function () {
    $('img.lazy').Lazy({
        scrollDirection: 'vertical',
        effect: 'fadeIn',
        visibleOnly: true,
        afterLoad: function (element) {
            sameHeight();
        }
    });

    $('.open-modal').on('click', function (e) {
        e.preventDefault();

        var $images = $(this)
            .parents('div.image-row')
            .children()
            .find('img');

        var activeImage = $(this).parent().index();

        appendImageModalSlideshow($images, activeImage);
    });

    $(document).bind('keyup', function (e) {
        if (e.which == 39) {
            $('.carousel').carousel('next');
        } else if (e.which == 37) {
            $('.carousel').carousel('prev');
        }
    });

    $("#exampleLanguageSelect").change(function () {
        $(this).parents('form').submit();
    });

    $("table#adminAppExampleTable, table#userAppExampleTable, table#adminUserTable").DataTable({
        "language": {
            "url": "/translations/german.json"
        },
        "order": [],
        "columnDefs": [{
            "targets": "nosort",
            "orderable": false
        }]
    });

    tinymce.baseURL = '/js/tinymce';
    tinymce.suffix = '.min';

    var $tinyMCEOptions = {
        theme: "modern",
        theme_url: "/js/tinymce/themes/modern/theme.min.js",
        skin_url: "/css/tinymce/skins/lightgray/",
        relative_urls: false,
        remove_script_host: true,
        document_base_url: "/js/tinymce/",
        plugins: ['lists', 'paste'],
        menubar: false,
        statusbar: false,
        toolbar: 'bullist numlist outdent indent',
        paste_as_text: true
    };

    if (window.Laravel.appLocale === 'de') {
        $tinyMCEOptions.language_url = "/js/tinymce/langs/de.js";
        $tinyMCEOptions.language = 'de';
    }

    $('textarea.rte').tinymce($tinyMCEOptions);

    $('.toggle-product').on('click', function () {
        $(this).parents('.product-wrapper').find('.product-list-full').toggleClass('hidden');
        $(this).parents('.product-wrapper').find('.product-list-short').toggleClass('hidden');

        var $icon = $(this).parents('.product-wrapper').find('i.glyphicon');

        if ($icon.hasClass('glyphicon-plus')) {
            $(this).parents('.product-wrapper').find('i.glyphicon').removeClass('glyphicon-plus').addClass('glyphicon-minus');
        } else {
            $(this).parents('.product-wrapper').find('i.glyphicon').removeClass('glyphicon-minus').addClass('glyphicon-plus');
        }
    });

    if ($('input#internet_url').length > 0 && $('input#internet_url').val().length == 0) {
        $('input#internet_url').val('http://');
    }

    $('#account-image').on('change', function () {
        var $form = $(this).parents('form'),
            $formRedirectType = $form.find('#is_img_edit');

        if ($formRedirectType.length > 0) $formRedirectType.val('1');

        $(this).parents('form').submit();
    });

    $('.auto-submit').on('change', function () {
        $(this).closest('form').submit();
        $(this).closest('form').find('input, select').attr('disabled', true);
    });

    $('ul.example-rate-wrapper > li').on('mouseleave', function () {
        $(this).removeClass('hover').prevAll().removeClass('hover');
    });

    $('ul.example-rate-wrapper > li').on('mouseover', function () {
        $(this).addClass('hover').prevAll().addClass('hover');
    });

    $('ul.example-rate-wrapper > li > a').on('click', function (e) {
        e.preventDefault();

        $(this).parents('li').siblings('.selected').removeClass('selected');
        $(this).parents('li').addClass('selected').prevAll().addClass('selected');

        var value = $(this).data('rate-value');
        $(this).parents('form').find('select#example_rating_select').val(value);

        $(this).parents('form').find('button.submit_rating').attr('disabled', false);
    });
});

$(window).on('load', function () {
    if ($('.app-examples-wrapper').length > 0) {
        sameHeight();

        $(window).on('resize', function () {
            sameHeight();
        });
    }
});

function sameHeight()
{
    var maxHeightImage = 0,
        maxHeightHeadline = 0,
        maxHeightDesc = 0;

    $('.app-examples-wrapper > div').each(function () {
        var $domImage = $(this).find('.thumbnail > a').css('height', ''),
            $domHeadline = $(this).find('.caption > h3').css('height', ''),
            $domDesc = $(this).find('.product-wrapper').css('height', '');

        if ($domImage.outerHeight() > maxHeightImage) {
            maxHeightImage = $domImage.outerHeight();
        }

        if ($domHeadline.outerHeight() > maxHeightHeadline) {
            maxHeightHeadline = $domHeadline.outerHeight();
        }

        if ($domDesc.outerHeight() > maxHeightDesc) {
            maxHeightDesc = $domDesc.outerHeight();
        }
    });

    $('.app-examples-wrapper > div .thumbnail > a').css({'height': maxHeightImage + 'px'});
    $('.app-examples-wrapper > div .caption > h3').css({'height': maxHeightHeadline + 'px'});
    $('.app-examples-wrapper > div .product-wrapper').css({'height': maxHeightDesc + 'px'});
}
